import Home from "./pages/Home";
import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { Provider } from "react-redux";
import { persistor, store } from "./store/index";
import { PersistGate } from "redux-persist/integration/react";
import FullscreenProgress from "./components/layout/FullscreenProgress";

import MainLayout from "./layouts/MainLayout";
import CGV from "./pages/CGV";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import LegalNotice from "./pages/LegalNotice";
import AuthLayout from "./layouts/AuthLayout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import CodeVerification from "./pages/CodeVerification";
import Restaurants from "./pages/Restaurants";
import ResetPassword from "./pages/ResetPassword";
import RestaurantDetails from "./pages/RestaurantDetails";
import Checkout from "./pages/Checkout";
import PaymentSuccess from "./pages/PaymentSuccess";
import ProtectedRoute from "./components/layout/ProtectedRoute";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RestaurantRequest from "./pages/RestaurantRequest";
import RiderRequest from "./pages/RiderRequest";
import { ROUTES } from "./configs";
import CurrentOrders from "./pages/CurrentOrders";
import Profile from "./pages/Profile";
import OrdersHisotry from "./pages/OrdersHistory";
import OrderDetails from "./pages/OrderDetails";

const App: React.FC = () => {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        {/* Main Layout Routes */}
        <Route
          path="/"
          element={<MainLayout />}
        >
          <Route
            index
            element={<Home />}
          />
          <Route
            path="/restaurants"
            element={<Restaurants />}
          />
          <Route
            path="/restaurants/:restaurantId"
            element={<RestaurantDetails />}
          />
          <Route
            path="/cgv"
            element={<CGV />}
          />
          <Route
            path="politique-de-confidentialite"
            element={<PrivacyPolicy />}
          />
          <Route
            path="mentions-legales"
            element={<LegalNotice />}
          />
          <Route
            path="mentions-legales"
            element={<LegalNotice />}
          />
          <Route
            path={ROUTES.RESTAURANT_REQUEST}
            element={<RestaurantRequest />}
          />
          <Route
            path={ROUTES.RIDER_REQUEST}
            element={<RiderRequest />}
          />
          <Route
            path="checkout"
            element={
              <ProtectedRoute
                Element={Checkout}
                redirectTo="/auth/login"
              />
            }
          />
          <Route
            path="current-orders"
            element={
              <ProtectedRoute
                Element={CurrentOrders}
                redirectTo="/auth/login"
              />
            }
          />
          <Route
            path="profile"
            element={
              <ProtectedRoute
                Element={Profile}
                redirectTo="/auth/login"
              />
            }
          />
          <Route
            path="history"
            element={
              <ProtectedRoute
                Element={OrdersHisotry}
                redirectTo="/auth/login"
              />
            }
          />
          <Route
            path="history/:orderId"
            element={
              <ProtectedRoute
                Element={OrderDetails}
                redirectTo="/auth/login"
              />
            }
          />
        </Route>

        {/* Auth Layout Routes */}
        <Route
          path="/auth"
          element={<AuthLayout />}
        >
          <Route
            path="login"
            element={<Login />}
          />
          <Route
            path="register"
            element={<Register />}
          />
          <Route
            path="forgot-password"
            element={<ForgotPassword />}
          />
          <Route
            path="reset-password"
            element={<ResetPassword />}
          />
          <Route
            path="verify-code"
            element={<CodeVerification />}
          />
        </Route>

        <Route
          path="success"
          element={<PaymentSuccess />}
        />
      </>
    )
  );

  return (
    <Provider store={store}>
      <PersistGate
        loading={<FullscreenProgress />}
        persistor={persistor}
      >
        <RouterProvider router={router} />
        <ToastContainer
          position="bottom-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </PersistGate>
    </Provider>
  );
};

export default App;
